<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-01-13                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-modal ref="modal_form"
           :size="size"
           centered
           no-close-on-backdrop
           no-close-on-esc
           :hide-header="noHeader"
           v-on:hidden="handleHidden"
           hide-footer>
    <template v-slot:modal-header v-if="!noHeader">
      <slot name="header" v-bind:item="localItem"></slot>
    </template>
    <b-form v-on:input="handleInput($event)" novalidate validated>
      <slot name="fields" v-bind:item="localItem" v-bind:isnew="isNew"></slot>
      <b-button v-if="isNew" :disabled="isInvalid || !isDirty" variant="primary" class="mr-1" @click="save">Save</b-button>
      <b-button v-if="!isNew" :disabled="isInvalid || !isDirty" variant="primary" class="mr-1" @click="update">Update</b-button>
      <b-button variant="outline-secondary" class="mr-1" @click="cancel()" v-if="!noCancel">Cancel</b-button>
      <b-button v-if="!isNew && !isDirty && !noDestroy" class="mr-1" variant="link" @click="destroy()">Delete</b-button>
      <b-button v-if="isDirty" variant="link" class="mr-1" @click="reset()">Reset</b-button>
    </b-form>
  </b-modal>
</template>

<script>
import RespondsTo from "./responds-to"
import useAttributesHashToString from "../../../compositions/use-attributes-hash-to-string";
import usePricesStoreToPricesText from "../../../compositions/use-prices-store-to-prices-text";

export default {
  name: "yega1-modal-form",
  provide(){
    return{
      setDirty: this.setDirty,
    };
  },
  inject:{
    registerDialog: 'registerDialog',
    handleItemSaved: 'handleItemSaved',
    handleItemUpdated:'handleItemUpdated',
    handleItemDestroyed: 'handleItemDestroyed'
  },
  setup(){
    const { attributesHashToString } = useAttributesHashToString();
    const { priceStoreToPricesText } = usePricesStoreToPricesText();
    return {
      attributesHashToString,
      priceStoreToPricesText
    };
  },
  data(){
    return{
      originalItem:{},
      localItem:{
        attribute_store:{}
      },
      isDirty:false,
      isInvalid:false,
      isNew:false
    }
  },
  props:{
    size:{
      type:String,
      default:'lg'
    },
    noHeader:Boolean,
    storeName:String,
    noDestroy:Boolean,
    beforeSave:{
      type:Function
    },
    beforeUpdate:{
      type:Function
    },
    itemClass:{
      type:Function
    },
    noCancel:{
      type: Boolean,
      default:false
    },
    convertToAttributesString:{
      type: Boolean,
      default: false
    },
    convertToAttributesJson:{
      type: Boolean,
      default: false
    },
    convertToPricesText:{
      type: Boolean,
      default: false
    }
  },
  created(){
    this.registerDialog(this);
  },
  methods:{
    handleInput:function(event){
      this.$emit('input-event',event);
      this.isInvalid = false;
      for(let i=0; i < event.currentTarget.elements.length;i++){
        let element = event.currentTarget.elements[i];
        if(element.validity && !element.validity.valid){
          this.isInvalid = true;
        }
      }
      this.isDirty = true;
    },
    handleHidden(){
      this.$emit('form-hidden');
    },
    initializeItem(item){
      if(this.itemClass){
        this.originalItem   = new this.itemClass(item,this.$store);
        this.localItem      = new this.itemClass(item,this.$store);
      }else{
        this.originalItem   = item;
        this.localItem      = Object.assign({}, this.originalItem);
      }
      this.isDirty        = false;
    },
    save(){
      const that = this;

      if(this.beforeSave){
        this.beforeSave(this.localItem);
      }
      if(RespondsTo.item_responds_to(this.localItem,'beforeSave')){
        this.localItem.beforeSave();
      }

      if(!!this.localItem.attribute_store && this.convertToAttributesString){
        this.localItem.attributes_string = this.attributesHashToString(this.localItem.attribute_store);
      }
      if(!!this.localItem.attribute_store && this.convertToAttributesJson){
        this.localItem.attributes_json = JSON.stringify(this.localItem.attribute_store);
      }
      if(!!this.localItem.price_store && this.convertToPricesText){
        this.localItem.prices_text = this.priceStoreToPricesText(this.localItem.price_store);
      }

      this.$store
          .dispatch(`${this.storeName}/create`, this.localItem)
          .then((savedItem)=>{
            this.initializeItem(savedItem);
            this.handleItemSaved(savedItem);
            that.$emit('item-saved',savedItem);
            that.$refs.modal_form.hide();
          })
          .catch((error)=>{
            that.$refs.modal_form.show();
            alert(error.response ? error.response.data : error);
          });
    },
    update(){
      const that = this;

      if(this.beforeUpdate){
        if(this.beforeUpdate(this.localItem) === false){
          return;
        }
      }
      if(RespondsTo.item_responds_to(this.localItem,'beforeUpdate')){
        this.localItem.beforeUpdate();
      }

      if(!!this.localItem.attribute_store && this.convertToAttributesString){
        this.localItem.attributes_string = this.attributesHashToString(this.localItem.attribute_store);
      }
      if(!!this.localItem.attribute_store && this.convertToAttributesJson){
        this.localItem.attributes_json = JSON.stringify(this.localItem.attribute_store);
      }
      if(!!this.localItem.price_store && this.convertToPricesText){
        this.localItem.prices_text = this.priceStoreToPricesText(this.localItem.price_store);
      }

      this.$store
          .dispatch(`${this.storeName}/update`, this.localItem)
          .then((updatedItem)=>{
            this.initializeItem(updatedItem);
            this.handleItemUpdated(updatedItem);
            that.$emit('item-updated',updatedItem);
            that.$refs.modal_form.hide();
          })
          .catch((error)=>{
            that.$refs.modal_form.show();
            alert(error.response ? error.response.data : error);
          });
    },
    reset(){
      if(this.itemClass){
        this.localItem = new this.itemClass(Object.assign({}, this.originalItem));
      }else{
        this.localItem = Object.assign({}, this.originalItem);
      }
      this.$emit('item-initialized',this.localItem);
      this.isDirty = false;
    },
    cancel(){
      this.$refs.modal_form.hide();
      this.$emit('cancelled');
    },
    destroy(){
      if(!confirm('Are you sure you would like to delete?')){
        return;
      }
      const that = this;
      this.$store
          .dispatch(`${this.storeName}/destroy`, this.localItem.id)
          .then(()=>{
            that.$emit('item-destroyed');
            this.handleItemDestroyed();
            that.$refs.modal_form.hide();
          })
          .catch((error)=>{alert(error.response ? error.response.data : error);});
    },
    newItem(item_template){
      const that = this;
      let initial_item = {attribute_store:{}};
      if(item_template){
        initial_item = item_template;
      }

      this.$store.dispatch(`${this.storeName}/initialize`, initial_item)
          .then((initializedItem)=>{
            that.initializeItem(initializedItem);
            that.$emit('item-initialized',this.localItem);
            that.isNew= true;
            that.$refs.modal_form.show();
          })
          .catch((error)=>{alert(error.response ? error.response.data : error);});
    },
    loadItem(id){
      const that = this;
      this.$store.dispatch(`${this.storeName}/show`, id)
          .then((loadedItem)=>{
            that.initializeItem(loadedItem);
            that.$emit('item-loaded',this.localItem);
            that.isNew= false;
            that.$refs.modal_form.show();
          })
          .catch((error)=>{alert(error.response ? error.response.data : error);});
    },
    setDirty(){
      this.isDirty = true;
    }
  }
}
</script>

<style scoped>

</style>
